<template>
  <div>
    <div class="header pb-6 d-flex align-items-center profile-header">
      <!-- Mask -->
      <span class="mask bg-gradient-default"></span>
      <!-- Header container -->
      <b-container fluid class="align-items-center dashboard-container">
        <b-row style="width: 100%;" class="justify-content-center">
          <b-col lg="10" class="justify-content-center">
            <slot name="headertext" v-bind:website="website"></slot>
          </b-col>
        </b-row>

        <b-row class="justify-content-center" style="margin-top: 30px;">
          <b-col lg="10" class="justify-content-center">
            <b-alert show variant="success">
              <span class="alert-icon"><i class="ni ni-like-2"></i></span>
              <span class="alert-text">
                <div class="alert-text-header">
                  All systems operational.
                </div>
                <div class="alert-text-sub">
                  <span v-if="userOwnsWebsite">
                    Your infrastructure is up and running.
                  </span>
                  <span v-else>
                    No recent problems reported.
                  </span>
                </div>
              </span>
            </b-alert>
          </b-col>
        </b-row>

        <!--
        <b-row class="justify-content-center" style="margin-top:30px">
          <b-col lg="10" class="justify-content-center">
            <b-alert show variant="success">
              <span class="alert-icon"><i class="ni ni-like-2"></i></span>
              <span class="alert-text">
                <strong>
                  No ongoing incidents, as of 10:45pm.
                </strong>
              </span>
            </b-alert>
          </b-col>
        </b-row>
        -->
      </b-container>
    </div>

    <b-container></b-container>

    <b-container fluid class="mt--6 monitor-background">
      <b-row>
        <b-col lg="5" offset-lg="1">
          <uptime-chart
            v-bind:website="website"
            v-bind:uptime-obj="uptimeObj"
          ></uptime-chart>
        </b-col>
        <b-col lg="5">
          <recent-incidents
            v-bind:website="website"
            v-bind:uptime-obj="uptimeObj"
          ></recent-incidents>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col lg="10">
          <!--
          <b-row>
            <b-col md="6">
              <card gradient="info" class="border-0 monitor-card card-success">
                <b-row>
                  <b-col cols="10">
                    <h5
                      class="card-title text-uppercase text-muted mb-0 text-white"
                    >
                      Status
                    </h5>
                    <span class="h2 font-weight-bold mb-0 text-white">
                      All systems operational
                    </span>
                  </b-col>
                  <b-col cols="1">
                    <div
                      class="icon icon-shape bg-white text-dark rounded-circle shadow"
                    >
                      <i class="ni ni-active-40"></i>
                    </div>
                  </b-col>
                </b-row>
                <p class="mt-3 mb-0 text-sm">
                  <span class="text-nowrap text-white">
                    As of
                    {{ updatedAt | moment("h:mm a") }}
                  </span>
                </p>
              </card>
            </b-col>
            <b-col md="6">
              <card gradient="danger" class="border-0 monitor-card">
                <b-row>
                  <b-col cols="10">
                    <h5
                      class="card-title text-uppercase text-muted mb-0 text-white"
                    >
                      Uptime
                    </h5>
                    <span class="h2 font-weight-bold mb-0 text-white">
                      {{ website.totalAvgUptime || 100 }}%
                    </span>
                  </b-col>
                  <b-col cols="2">
                    <div
                      class="icon icon-shape bg-white text-dark rounded-circle shadow"
                    >
                      <i class="ni ni-spaceship"></i>
                    </div>
                  </b-col>
                </b-row>
                <p class="mt-3 mb-0 text-sm">
                  <span class="text-nowrap text-light">Last 7 days</span>
                </p>
              </card>
            </b-col>
          </b-row>

          -->

          <b-row v-if="userOwnsWebsite">
            <b-col>
              <b-alert show variant="default">
                <span class="alert-icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-text">
                  <strong>
                    Monitoring {{ numComponents }} /
                    {{ componentsMonitoredLimit }} components.
                  </strong>
                  Your plan lets you monitor
                  {{ componentsMonitoredLimit }} components.
                  <span v-if="!hasPremium">
                    <router-link class="text-white" to="/pricing">
                      Upgrade now
                    </router-link>
                    to monitor more.
                  </span>
                </span>
              </b-alert>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <component-table
                v-bind:data="components"
                :owns-current-website="userOwnsWebsite"
                v-on:refresh="refreshData"
              >
                <template v-slot:header>
                  <modal ref="addModal" :show.sync="modal" title="Edit">
                    <h6 slot="header" class="modal-title">Add Component</h6>
                    <b-form-group>
                      <b-input-group prepend="Name">
                        <b-form-input
                          v-model="addComponentName"
                          placeholder="BoltScale"
                        ></b-form-input>
                      </b-input-group>
                      <b-input-group prepend="URL">
                        <b-form-input
                          v-model="addComponentUrl"
                          :type="'url'"
                          placeholder="https://api.boltscale.io"
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>

                    <template v-slot:footer>
                      <base-button @click="hideModal()" type="secondary">
                        Cancel
                      </base-button>
                      <base-button @click="addComponent()" icon type="primary">
                        Submit
                      </base-button>
                    </template>
                  </modal>

                  <base-button
                    v-if="userOwnsWebsite"
                    :disabled="numComponents >= componentsMonitoredLimit"
                    @click="modal = true"
                    type="default"
                    size="sm"
                    class="float-right"
                  >
                    Add
                  </base-button>
                  <h3 class="mb-0">Components</h3>
                  <h5 class="mt-0 mb-0 text-light">
                    All the services that {{ website.name }} owns.
                  </h5>
                </template>
              </component-table>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <component-table
                v-bind:data="dependencies"
                :owns-current-website="userOwnsWebsite"
                v-bind:thirdparty="true"
                v-on:refresh="refreshData"
              >
                <template v-slot:header>
                  <modal
                    ref="thirdPartyComponentModal"
                    :show.sync="thirdPartyComponentModal"
                    title="Edit"
                    size="lg"
                  >
                    <h6 slot="header" class="modal-title">
                      Add Third-party Component
                    </h6>

                    <paginated-tables
                      v-on:apiSelected="thirdPartyComponentSelectionChange"
                    >
                      <template slot="header">
                        <h3 class="mb-0">
                          Search for a third-party component to add.
                        </h3>
                        <p class="text-sm mb-0">
                          If any are missing, you can add custom components
                          above.
                        </p>
                      </template>
                    </paginated-tables>

                    <template v-slot:footer>
                      <base-button
                        @click="hideThirdPartyModal()"
                        type="secondary"
                      >
                        Cancel
                      </base-button>
                      <base-button
                        @click="addThirdPartyComponent()"
                        icon
                        type="primary"
                      >
                        Submit
                      </base-button>
                    </template>
                  </modal>
                  <base-button
                    v-if="userOwnsWebsite"
                    :disabled="numComponents >= componentsMonitoredLimit"
                    @click="thirdPartyComponentModal = true"
                    type="default"
                    size="sm"
                    class="float-right"
                  >
                    Add
                  </base-button>
                  <h3 class="mb-0">Third-Party Components</h3>
                  <h5 class="mt-0 mb-0 text-light">
                    Third-party services that {{ website.name }} uses.
                  </h5>
                </template>
              </component-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import ComponentTable from "@/views/Custom/ComponentTable";
import moment from "moment";
import PaginatedTables from "@/views/Tables/PaginatedTables";
import UptimeChart from "@/components/UptimeChart";
import RecentIncidents from "@/components/RecentIncidents";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "BaseStatusPage",
  components: {
    ComponentTable,
    PaginatedTables,
    UptimeChart,
    RecentIncidents
  },
  data() {
    return {
      uptimeObj: [],
      websiteNotifyModal: false,
      name: "",
      addComponentName: "",
      addComponentUrl: "",
      modal: false,
      thirdPartyComponentModal: false,
      thirdPartyComponentSelected: []
    };
  },
  computed: {
    dependencies: function () {
      const dependencies = [];
      for (const c of this.website.components) {
        if (c.dependency) {
          dependencies.push(c);
        }
      }
      return dependencies;
    },
    components: function () {
      const components = [];
      for (const c of this.website.components) {
        if (!c.dependency) {
          components.push(c);
        }
      }
      return components;
    },

    ...mapGetters("website", ["userOwnsWebsite", "numComponents"]),
    ...mapGetters("user", ["componentsMonitoredLimit", "hasPremium"]),
    ...mapState("website", {
      website: (state) => state.data
    })
  },

  watch: {
    website: async function (newVal, oldVal) {
      const endpoint = `/incidents/${newVal.website_url}`;
      const resp = await this.$http.get(endpoint);
      this.uptimeObj = resp.data.uptimeObj;
    }
  },

  methods: {
    hideModal() {
      this.$refs.addModal.closeModal();
    },
    hideThirdPartyModal() {
      this.$refs.thirdPartyComponentModal.closeModal();
    },
    thirdPartyComponentSelectionChange(allSelectedRows) {
      console.log("Third party component added!");
      console.log(allSelectedRows);
      this.thirdPartyComponentSelected = allSelectedRows;
    },
    addThirdPartyComponent() {
      console.log("Third party component is now being added!");
      console.log(this.thirdPartyComponentSelected);
      this.$http
        .post("/components/thirdParty/add", this.thirdPartyComponentSelected)
        .then((resp) => {
          console.log(resp);
          this.refreshData();
        });
      this.$refs.thirdPartyComponentModal.closeModal();
    },
    addComponent() {
      const name = this.addComponentName;
      const url = this.addComponentUrl;

      this.$http
        .post("/components/add", { name: name, endpoint: url })
        .then((resp) => {
          console.log(resp);
          this.refreshData();
        });
      this.$refs.addModal.closeModal();
      console.log("ADDING COMPONENT");
    },
    async refreshData() {
      console.log("BEGINNING TO PING AXIOS!");
      let name = "";
      if (this.$route.params.name) {
        name = this.$route.params.name.replace(/_/g, " ");
        //this.website.name = name;
      }
      this.getWebsite(name);
    },
    ...mapActions("website", ["getWebsite"])
  },
  async created() {
    this.refreshData();

    if (this.$route.query && this.$route.query.code) {
      console.log("Code is attained! POSTing our server...");
      const resp = await this.$http.get("/webhook/slack", {
        params: {
          code: this.$route.query.code,
          componentId: this.$route.query.componentId,
          websiteId: this.$route.query.websiteId
        }
      });
      console.log("AMAZNIG we posted!");
      console.log(resp);

      this.$toasted.show("Success! You'll get notified for any issues.", {
        type: "success",
        duration: 5000
      });
    }

    this.$gtag.event("generate_lead");
    this.$analytics.fbq.event("ViewContent");
  }
};
</script>
<style>
/*@incude media-breakpoint-down(lg) { */

.alert-text-header {
  font-size: 20px;
  font-weight: 600;
}

.alert-text-sub {
  padding-top: 3px;
  font-size: 14px;
}

.dashboard-container {
  margin-top: 45px;
}

.route-monitor .dashboard-container {
  margin-top: 95px;
}

.monitor-background {
  background-color: #f6f9fc;
}
.profile-header {
  /*background-image: url(/img/theme/profile-cover.jpg);*/
  background-size: cover;
  background-position: center top;
  min-height: 400px;
}
.monitor-card {
  background: #5e72e4 !important;
}

.monitor-card.card-success {
  background: #2bce89 !important;
}
</style>
